import Vue from 'vue';
import VueRouter from 'vue-router';

import NoNote from '@/views/NoNote.vue';
import NoteEditor from '@/views/NoteEditor.vue';
import TheNotes from '@/views/TheNotes.vue';

import AboutSettings from '@/views/settings/AboutSettings.vue';
import BackupSettings from '@/views/settings/BackupSettings.vue';
import GeneralSettings from '@/views/settings/GeneralSettings.vue';
import GoogleDriveBackupSettings from '@/views/settings/GoogleDriveBackupSettings.vue';
import TheSettings from '@/views/settings/TheSettings.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    redirect: {
      name: 'notes',
    },
  },
  {
    path: '/notes',
    component: TheNotes,
    children: [
      {
        path: '',
        name: 'notes',
        component: NoNote,
      },
      {
        path: ':id',
        name: 'note-editor',
        component: NoteEditor,
      },
    ],
  },
  {
    path: '/settings',
    component: TheSettings,
    children: [
      {
        path: 'general',
        name: 'settings-general',
        component: GeneralSettings,
      },
      {
        path: 'backup',
        name: 'settings-backup',
        component: BackupSettings,
      },
      {
        path: 'backup/google-drive',
        name: 'settings-backup-google-drive',
        component: GoogleDriveBackupSettings,
      },
      {
        path: 'about',
        name: 'settings-about',
        component: AboutSettings,
      },
    ],
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
